import { useMemo } from 'react';
import { DateTime } from 'luxon';

type PropsAgeFromDate = {
  value: string;
  fromDate?: string | null;
  className?: string;
  format?: string;
  isIso?: boolean;
}

export function AgeFromDate(
  {
    value,
    className,
    format = 'yyyy-MM-dd',
    isIso = false,
    fromDate = null
  }: PropsAgeFromDate
) {
  const age = useMemo(() => {
    let fechaActual: string | DateTime<boolean> = fromDate || DateTime.now();
    if (typeof fechaActual === 'string') {
      fechaActual = DateTime.fromISO(fechaActual);
    }
    const fechaNac = isIso ? DateTime.fromISO(value) : DateTime.fromFormat(value, format);
    const edad = fechaActual.diff(fechaNac, 'years').years;
    return Math.floor(edad);
  }, [format, fromDate, isIso, value]);
  return (
    <span className={className}>
      {age}
    </span>
  );
}

export default AgeFromDate;
